import { Outlet } from "react-router-dom";
import BaggageScan from "./BaggageScan";

export const adminBaggageScanRoutes = [
  {
    path: "baggage-scan",
    element: Outlet,
    children: [
      {
        path: "",
        element: BaggageScan,
      },
    ],
  },
];
